import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 26\" id=\"icon-plus\"><path d=\"M13 4v18m-9-9h18\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"square\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol